module.exports = __webpack_public_path__ + "static/media/StripesPurpl.c12aa184.png";